// extracted by mini-css-extract-plugin
module.exports = {"base":"TranslationsManager_base__J5b6N","withActionSection":"TranslationsManager_with-action-section__1VVAj"};